<template>
  <Loading v-if="componentLoading" :style="style" />
  <view v-else class="pft-article-style-1-component" :style="style" flex="dir:left">
    <template v-if="list.length > 0">
      <view v-for="(item, index) of list" class="article-item" :key="index" :style="getTabStyle(index)" flex="dir:top">
        <view :class="{ 'article-title': true }" flex="dir:left main:justify cross:center">
          <view flex="dir:left cross:center">
            <view class="text-title" :style="titleStyle">{{ item[titleKey] }}</view>
          </view>
        </view>
        <div class="article-contain" :style="item.contentStyle" :ref="addRef">
          <div class="article-scroll-container" :ref="addScrollRef">
            <div class="article-contain-pice" :style="contentStyle" v-html="item[contentKey]"></div>
          </div>
        </div>
      </view>
    </template>
    <template v-else>
      <view class="empty-placeholder">暂无数据</view>
    </template>
  </view>
</template>

<script lang="ts" setup>
import { ref, nextTick, onMounted } from "vue"
import Loading from "@p-v/packages/Loading.vue"
import { v4 } from "uuid"
const domId = ref(`uuid_${v4()}`)
interface DataTextProps {
  style?: { [key: string]: string }
  titleStyle?: { [key: string]: string }
  contentStyle?: { [key: string]: string }
  titleKey: string
  contentKey: string
  duration?: number
}

const props = withDefaults(defineProps<DataTextProps>(), {
  style: () => ({ width: "100%", height: "100%" }),
  titleStyle: () => ({}),
  contentStyle: () => ({}),
  titleKey: () => "",
  contentKey: () => "",
  duration: () => 5000,
})
// 获取插槽内容

const componentLoading = ref<boolean>(true)

const styleElement = ref<HTMLStyleElement | null>(null)
let activeIndex = ref(0)
let contentRefs = ref<HTMLBaseElement[]>([])
let scrollContentRefs = ref<HTMLBaseElement[]>([])

const addRef = (ref: HTMLBaseElement) => {
  // console.log(ref)
  contentRefs.value.push(ref)
}

const addScrollRef = (ref: HTMLBaseElement) => {
  // console.log(ref)
  scrollContentRefs.value.push(ref)
}

let slotTabStyle = ref({})
let list = ref<{ [key: string]: string | number | any }[]>([])
defineOptions({
  name: "PftArticle",
})
let timer: any = null
const changeTab = async (key: number) => {
  if (timer) {
    clearTimeout(timer)
  }
  if (activeIndex.value === list.value.length - 1) {
    activeIndex.value = 0
  } else {
    activeIndex.value += key
  }

  slotTabStyle.value = {
    transform: `translateX(${-activeIndex.value * 100}%)`,
  }
  const curContentDom = contentRefs.value[activeIndex.value]
  const curScrollContentDom = scrollContentRefs.value[activeIndex.value]
  const curContentDomHeight = curContentDom.offsetHeight
  const curContentDomScrollHeight = curScrollContentDom.scrollHeight

  let playState = "paused"
  let sec = props.duration
  let heightDiff = curContentDomScrollHeight - curContentDomHeight + 10

  if (curContentDomScrollHeight > curContentDomHeight) {
    playState = "running"
    sec = (curContentDomScrollHeight / curContentDomHeight) * props.duration
  }
  list.value[activeIndex.value].contentStyle = {
    ["--pft-article-height"]: `${curContentDomHeight}px`,
    ["--pft-article-sec"]: `${sec / 1000}s`,
    ["--pft-article-play-state"]: playState,
    ["--pft-article-play-height"]: `-${heightDiff}px`,
    ["--pft-article-play-animater"]: `pft_${domId.value}_rollup_${activeIndex.value}`,
  }
  list.value
    .filter((item, index) => index !== activeIndex.value)
    .forEach(item => {
      item.contentStyle = {
        ["--pft-article-play-state"]: "paused",
      }
    })
  updatePseudoElementStyle()
  timer = setTimeout(() => {
    changeTab(1)
  }, sec)

  // console.log("curContentDom", curContentDom, curContentDom.offsetHeight, curContentDom.scrollTop, curContentDom.scrollHeight)
}

const updatePseudoElementStyle = () => {
  if (styleElement.value) {
    let styleString = ""
    for (let i = 0; i < list.value.length; i++) {
      styleString += `
@keyframes pft_${domId.value}_rollup_${i} {
  0% {
    transform: translate3d(0, 0, 0);
  }
  20% {
    transform: translate3d(0, 0, 0);
  }
  80% {
    transform: translate3d(0, var(--pft-article-play-height, -100%), 0);
  }
  100% {
    transform: translate3d(0, var(--pft-article-play-height, -100%), 0);
  }
}
      `
    }
    styleElement.value.innerHTML = styleString
  }
}

const getTabStyle = (index: number) => {
  return {
    opacity: index === activeIndex.value ? 1 : 0,
    transform: `translateX(${-activeIndex.value * 100}%)`,
  }
}

const loading = () => {
  componentLoading.value = true
}

const setData = (data: { list: { [key: string]: string | number }[] }) => {
  list.value = data.list
  componentLoading.value = false
  nextTick(() => {
    changeTab(0)
  })
}
defineExpose({ setData, loading })
onMounted(async () => {
  styleElement.value = document.createElement("style")
  document.head.appendChild(styleElement.value)
})
// console.log(slots, tabsPageKeys)
</script>
<style lang="scss">
@keyframes pft_article_rollup {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, -100%, 0);
  }
}
.pft-article-style-1-component {
  padding: 16px;
  box-sizing: border-box;
  overflow: hidden;
  .article-item {
    opacity: 0;
    transition: all 1s;
    width: 100%;
    flex-shrink: 0;
  }
  .article-title {
    margin-bottom: 7px;
    position: relative;
    &.tabs {
      margin-bottom: 20px;
    }
    .title-icon {
      display: flex;
      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }
    .text-title {
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: bold;
      font-size: 16px;
      line-height: 19px;
      text-align: left;
      color: #cbe5fe;
    }
    .tabs {
      border-radius: 20px;
      border: 2px solid rgba(255, 255, 255, 0.2);
      height: 32px;
      line-height: normal;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      color: #fff;
      .tab {
        padding: 4px 16px;
        font-size: 14px;
        cursor: pointer;
        &.active {
          background: #2b97f7;
          border-radius: 32px;
        }
      }
    }
  }
  .article-scroll-container {
    box-sizing: border-box;
    animation-name: var(--pft-article-play-animater, pft_article_rollup);
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-play-state: var(--pft-article-play-state, paused); /* 动画默认运行 */
    animation-duration: var(--pft-article-sec, 20s);
    display: block;
    height: 100%;
    width: 100%;
    &.paused {
      animation-play-state: paused;
    }
  }
  .article-contain {
    // background: rgba(29, 45, 71, 0.75);
    // border-radius: 12px 12px 12px 12px;
    // padding: 16px;
    height: 50px;
    flex-grow: 1;
    overflow-y: hidden;
    .article-contain-pice {
      display: block;
      width: 100%;
      min-height: var(--pft-article-height, 100%);
      box-sizing: border-box;
    }

    @keyframes pft_article_rollup {
      0% {
        transform: translate3d(0, 0, 0);
      }
      20% {
        transform: translate3d(0, 0, 0);
      }
      100% {
        transform: translate3d(0, -100%, 0);
      }
    }
  }
}
.empty-placeholder {
  color: #fff;
  font-size: 16px;
  text-align: center;
  display: block;
  margin: auto;
}
</style>
